import { Skeleton } from '@core/design-system/tailwind/ui/skeleton';

export default function Loading() {
  return <Skeleton className="w-full h-[260px]" />;
}
